import { useAuth } from '@/config/auth/AuthProvider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import { Markdown, Modal } from '@/components';
import { Button, Modal as SemiModal } from '@douyinfe/semi-ui';
import { DOMUtils } from '@/utils';

export enum FeatureName {
  custom_api = 'custom_api',
  sync_service = 'sync_service',
  webhook = 'webhook',
  kafka = 'kafka'
}

export const useWhiteList = (type: FeatureName, options?: {
  rollback: boolean
  isEnterprise?: boolean
}) => {
  const { user } = useAuth();
  const { rollback = false, isEnterprise = false } = options || {};
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentModal, setCurrentModal] = React.useState<ReturnType<typeof SemiModal.info>>();

  useEffect(() => () => {
    if (currentModal) {
      currentModal.destroy();
    }
  }, [currentModal]);

  const checkWhitelist = useCallback(() => _.includes(user?.allowed_services, type), [user?.allowed_services, type]);

  const openRequestModal = useCallback((modalOptions?: {title?: string}) => {
    const { title } = modalOptions || {};
    const modal = Modal.info({
      title: title || t<string>('whitelistModal.title', { ns: 'translation' }),
      maskClosable: false,
      centered: true,
      content: (
        <div className="mt-[16px]">
          <p className="leading-5 mb-5">{isEnterprise ? t('sync.formContent2', { solution: '' }) : t<string>('whitelistModal.description', { ns: 'translation', name: t(`serviceDescription.${type}`) })}</p>

          <Markdown>{t<string>('whitelistModal.description2', { ns: 'translation' })}</Markdown>

          <div className="semi-modal-footer">
            <div>
              <Button
                theme="solid"
                onClick={() => {
                  window.location.replace('https://platform.chainbase.com/pricing');
                  modal.destroy();
                }}
              >
                {t('whitelistModal.upgradeNow', { ns: 'translation' })}
              </Button>

              <Button
                theme="light"
                type="primary"
                onClick={() => {
                  DOMUtils.open(`mailto:${t('contact.salesEmail')}`);
                  modal.destroy();
                }}
              >
                {t('whitelistModal.emailUs', { ns: 'translation' })}
              </Button>
            </div>
          </div>
        </div>
      ),
      afterClose() {
        if (rollback) {
          navigate(-1);
        }
      },
      footer: null
    });
    setCurrentModal(modal);
  }, [type]);
  return {
    checkWhitelist,
    openRequestModal
  };
};
